import { useQuery } from '@tanstack/react-query';

import { API_QUERY_KEYS } from 'consts';
import { useGetCurrentOrganisationId } from 'entities/user/api/hooks';

import { useGetCurrentBoardId } from 'entities/user/api/hooks/useGetCurrentBoardId';
import { getBoardGroups } from '../requests';

export const useGetBoardGroups = ({ enabled }: { enabled?: boolean } = {}) => {
  const boardId = useGetCurrentBoardId();
  const organisationId = useGetCurrentOrganisationId();

  return useQuery({
    queryKey: [API_QUERY_KEYS.boardGroups, { boardId, organisationId }],
    queryFn: () =>
      getBoardGroups({ pathParams: { boardId: boardId!, organisationId } }),
    enabled: (enabled ?? true) && !!boardId,
  });
};
